import { useCallback, useEffect, useRef, useState } from "react";
import api from "@/lib/api";

export default function useCockpitReports({ lang, clientId, userId, accountClientId }) {
  const scopeKey = JSON.stringify([userId, clientId || accountClientId || null, lang]);
  const currentScope = useRef(scopeKey);
  currentScope.current = scopeKey;
  const requestId = useRef(0);
  const mounted = useRef(false);
  const [state, setState] = useState(null);
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; requestId.current += 1; };
  }, []);
  const load = useCallback(async () => {
    if (!mounted.current || currentScope.current !== scopeKey) return;
    const id = ++requestId.current;
    const isCurrent = () => mounted.current && currentScope.current === scopeKey && requestId.current === id;
    setState({ scopeKey, data: null, error: false });
    try {
      const { data } = await api.get(`/cockpit/reports?lang=${encodeURIComponent(lang)}${clientId ? `&client_id=${encodeURIComponent(clientId)}` : ""}`);
      const expectedClient = clientId || accountClientId;
      if (!data || !Array.isArray(data.reports) || data.reports.some(r =>
        !r || typeof r.id !== "string" || !r.id || (expectedClient && r.client_id && r.client_id !== expectedClient))) {
        throw new Error("Invalid report response");
      }
      if (isCurrent()) setState({ scopeKey, data, error: false });
    } catch {
      if (isCurrent()) setState({ scopeKey, data: null, error: true });
    }
  }, [scopeKey, lang, clientId, accountClientId]);
  useEffect(() => { load(); }, [load]);
  const current = state?.scopeKey === scopeKey ? state : null;
  return { data: current?.data || null, loadError: !!current?.error, load, scopeKey };
}
